import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { environment } from '../config/environment';
import type { Form } from '../interfaces/form.interface';

const getForm = async (formId: string): Promise<Form> => {
  const response = await axios.get(
    `${environment.API}/forms/${formId}`,
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    }
  );
  return response.data;
};

export const useGetForm = (formId: string) => {
  return useQuery({
    queryKey: ['form', formId],
    queryFn: () => getForm(formId),
    enabled: !!formId,
  });
};
